import { memo } from 'react';
const SvgPieChart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="pie-chart_svg__feather pie-chart_svg__feather-pie-chart"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
    <path d="M22 12A10 10 0 0 0 12 2v10z" />
  </svg>
);
const Memo = memo(SvgPieChart);
export default Memo;
